import Page from 'components/page/Page';
import PageWrapper from 'components/pageWrapper/PageWrapper';

import { useEnv } from 'hooks/useEnv';
import { ScreenSize, useScreenSize } from 'hooks/useScreenSize';
import { useVenueCardAnimationPlayPause } from 'hooks/useVenueCardAnimationPlayPause';

import MarketFilters from './marketFilters/MarketFilters';
import MarketList from './marketList/MarketList';
import './MarketRoute.scss';
import MarketSkeleton from './marketSkeleton/MarketSkeleton';

const MarketRoute = () => {
  useVenueCardAnimationPlayPause();
  const screenSize = useScreenSize();
  const { useMarketMocks } = useEnv();

  if (useMarketMocks) {
    return <MarketSkeleton />;
  }

  return (
    <Page
      hideLoader
      requireTermsOfServiceConsents
      pageBackground="dark"
      withScrollbar={screenSize >= ScreenSize.mediumSmall}
    >
      <PageWrapper className="market" homeFooter={screenSize >= ScreenSize.mediumSmall}>
        <MarketFilters>
          <MarketList />
        </MarketFilters>
      </PageWrapper>
    </Page>
  );
};

export default MarketRoute;
